import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    ApproveCliSessionResponseSchema,
    ApproveCliSessionSchema,
    ClaimCliSessionResponseSchema,
    ClaimCliSessionSchema,
    CliSessionIdPathParamsSchema,
    CliSessionSchema,
    CreateCliSessionResponseSchema,
    CreateCliSessionSchema,
} from "../schemas/domains/cliSession/cli-session.schema";

const c = initContract();

/**
 * CLI-initiated login session.
 *
 * - `create` and `claim` are public. `create` is how the CLI starts the
 *   handshake; `claim` is how it picks up the plaintext PAT once the user
 *   approves. Both take care to not leak the plaintext to unauthorised
 *   callers (claim requires the raw device code; the server only stores a
 *   hash).
 * - `get`, `approve`, and `cancel` are SPA endpoints requiring a logged-in
 *   user (JWT). The consent page uses them to show session metadata, mint a
 *   PAT with the selected scope/workspace/expiry, or bail out.
 */
export const cliSessionContract = c.router(
    {
        create: {
            method: "POST",
            path: "/cli-session",
            body: CreateCliSessionSchema,
            responses: {
                201: CreateCliSessionResponseSchema,
                400: ErrorMessageSchema,
            },
        },
        get: {
            method: "GET",
            path: "/cli-session/:id",
            pathParams: CliSessionIdPathParamsSchema,
            responses: {
                200: CliSessionSchema,
                404: ErrorMessageSchema,
            },
        },
        approve: {
            method: "POST",
            path: "/cli-session/:id/approve",
            pathParams: CliSessionIdPathParamsSchema,
            body: ApproveCliSessionSchema,
            responses: {
                200: ApproveCliSessionResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                410: ErrorMessageSchema,
            },
        },
        cancel: {
            method: "POST",
            path: "/cli-session/:id/cancel",
            pathParams: CliSessionIdPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: ApproveCliSessionResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        claim: {
            method: "POST",
            path: "/cli-session/:id/claim",
            pathParams: CliSessionIdPathParamsSchema,
            body: ClaimCliSessionSchema,
            responses: {
                200: ClaimCliSessionResponseSchema,
                404: ErrorMessageSchema,
                429: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/oauth",
    },
);
